"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAdminPortals = exports["default"] = void 0;

var _reselect = require("reselect");

var _boxes = require("../boxes");

var _portals = require("./portals.actions");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var portalsById = function portalsById() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _portals.FIND_PORTALS_REQUEST:
      {
        var dynamicPaging = action.body.dynamicPaging;

        if (dynamicPaging.pageNumber > 0) {
          return state;
        }

        return {};
      }

    case _portals.FIND_PORTALS_SUCCESS:
    case _boxes.FIND_PORTALS_FOR_ASSET_ALLOCATION_SUCCESS:
      {
        var _action$body$portals = action.body.portals,
            portals = _action$body$portals === void 0 ? [] : _action$body$portals;
        var newState = portals.reduce(function (result, portal) {
          var existingPortal = state[portal.id];
          result[portal.id] = _objectSpread(_objectSpread({}, existingPortal), portal);
          return result;
        }, {});
        return _objectSpread(_objectSpread({}, state), newState);
      }

    case _portals.CREATE_PORTAL_SUCCESS:
      {
        var portal = action.body.portal;
        return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, portal.id, portal));
      }

    case _portals.ADMIN_UPDATE_PORTAL_SUCCESS:
    case _portals.ADMIN_FIND_PORTAL_SUCCESS:
      {
        var _portal = action.body.portal;
        var existingPortal = state[_portal.id];
        return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, _portal.id, _objectSpread(_objectSpread({}, existingPortal), _portal)));
      }

    default:
      {
        return state;
      }
  }
};

var allPortals = function allPortals() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _portals.FIND_PORTALS_REQUEST:
      {
        var dynamicPaging = action.body.dynamicPaging;

        if (dynamicPaging.pageNumber > 0) {
          return state;
        }

        return [];
      }

    case _portals.FIND_PORTALS_SUCCESS:
    case _boxes.FIND_PORTALS_FOR_ASSET_ALLOCATION_SUCCESS:
      {
        var _action$body$portals2 = action.body.portals,
            portals = _action$body$portals2 === void 0 ? [] : _action$body$portals2;
        var newState = portals.reduce(function (result, portal) {
          if (!state.some(function (id) {
            return id === portal.id;
          })) {
            result.push(portal.id);
          }

          return result;
        }, []);
        return [].concat(_toConsumableArray(state), _toConsumableArray(newState));
      }

    case _portals.CREATE_PORTAL_SUCCESS:
      {
        var portal = action.body.portal;
        return [].concat(_toConsumableArray(state), [portal.id]);
      }

    case _portals.ADMIN_UPDATE_PORTAL_SUCCESS:
    case _portals.ADMIN_FIND_PORTAL_SUCCESS:
      {
        var _portal2 = action.body.portal;

        if (state.some(function (id) {
          return id === _portal2.id;
        })) {
          return state;
        }

        return [].concat(_toConsumableArray(state), [_portal2.id]);
      }

    default:
      {
        return state;
      }
  }
};

var getAdminPortals = (0, _reselect.createSelector)([function (state) {
  return state.admin.portals.allIds;
}, function (state) {
  return state.admin.portals.byId;
}], function (allIds, portals) {
  return allIds.map(function (id) {
    return portals[id];
  });
});
exports.getAdminPortals = getAdminPortals;
var _default = {
  byId: portalsById,
  allIds: allPortals
};
exports["default"] = _default;